import { Component, inject } from "@angular/core";
import { FormControl, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { SessionService } from "src/services/session.service";
import { TemplatePasswordComponent } from "../../../prefixes/templates/template-password/template-password.component";
import { DialogTitle } from "../../template/dialog-template.component";
import { DialogComponent } from "../dialog.component";

export type SessionChangePasswordDialogData = {
  title: DialogTitle;
  actionId: string;
};

@Component({
  selector: "app-session-change-password-dialog",
  imports: [TranslateModule, MatButtonModule, TemplatePasswordComponent, FormsModule],
  templateUrl: "./session-change-password-dialog.component.html",
  styleUrl: "./session-change-password-dialog.component.less",
})
export class SessionChangePasswordDialogComponent extends DialogComponent<SessionChangePasswordDialogData> {
  private session: SessionService;

  public passwordControl = new FormControl<string | null>(null);
  public passwordConfirmControl = new FormControl<string | null>(null);

  public constructor() {
    super();
    this.session = inject(SessionService);
  }

  public async onSubmit(): Promise<void> {
    if (!this.data) throw new Error("No data");
    const { value: password } = this.passwordControl;
    const { value: passwordConfirm } = this.passwordConfirmControl;

    const result = await this.session.changePassword({
      FFWDActionID: this.data?.actionId,
      passwordnew: password || "",
      passwordrepeat: passwordConfirm || "",
    });

    if (result) {
      this.close();
      this.session.disconnect();
    }
  }
}
